import axios from "axios";
import {
  DiagnosticsResponse,
  WebsiteDiagnosticResponse,
  LeadCapturePayload,
  DiagnosticLeadCaptureResponse,
  DiagnosticLeadCaptureDetail,
  PublicDiagnosticReportResponse,
  DiagnosticLeadQuery,
  DiagnosticLeadPagedResult,
} from "../types/diagnostics";
import { DIAGNOSTIC_API_BASE_URL } from './apiConfig';

const api = axios.create({
  baseURL: DIAGNOSTIC_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const runWebsiteDiagnostics = async (payload: LeadCapturePayload): Promise<WebsiteDiagnosticResponse> => {
  const res = await api.post<WebsiteDiagnosticResponse>("/api/diagnostics/website", payload);
  return res.data;
};

export const runDiagnostics = async (urlOrQr: string): Promise<DiagnosticsResponse> => {
  const res = await api.post<any>("/api/diagnostics/website", { urlOrQr });
  return res.data;
};

export const getMyDiagnostics = async (): Promise<DiagnosticsResponse[]> => {
  const res = await api.get<any[]>("/api/diagnostics/website/my");
  return res.data;
};

export const runMarketingDiagnostics = async (
  payload: { answers: Record<string, string>; name?: string; company?: string; email?: string }
): Promise<DiagnosticLeadCaptureResponse> => {
  const res = await api.post<DiagnosticLeadCaptureResponse>("/api/diagnostics/marketing", payload);
  return res.data;
};

export const getMarketingQuestions = async () => {
  const res = await api.get("/api/diagnostics/marketing/questions");
  return res.data;
};

export const runBusinessAssessment = async (
  payload: { answers: Record<string, string>; name?: string; email?: string; companyName?: string }
): Promise<DiagnosticLeadCaptureResponse> => {
  const res = await api.post<DiagnosticLeadCaptureResponse>("/api/diagnostics/business-assessment", payload);
  return res.data;
};

export const getBusinessQuestions = async () => {
  const res = await api.get("/api/diagnostics/business-assessment/questions");
  return res.data;
};

export const getPublicDiagnosticReport = async (token: string): Promise<PublicDiagnosticReportResponse> => {
  const res = await api.get<PublicDiagnosticReportResponse>(`/api/diagnostics/report/${token}`);
  return res.data;
};

export const getMarketingDiagnosticLeads = async (): Promise<DiagnosticLeadCaptureDetail[]> => {
  const res = await api.get<DiagnosticLeadCaptureDetail[]>("/api/diagnostics/leads/marketing");
  return res.data;
};

export const getBusinessDiagnosticLeads = async (): Promise<DiagnosticLeadCaptureDetail[]> => {
  const res = await api.get<DiagnosticLeadCaptureDetail[]>("/api/diagnostics/leads/business");
  return res.data;
};

export const getDiagnosticLeadDetail = async (id: string): Promise<DiagnosticLeadCaptureDetail> => {
  const res = await api.get<DiagnosticLeadCaptureDetail>(`/api/diagnostics/leads/${id}`);
  return res.data;
};

export async function getDiagnosticLeads(
  query: DiagnosticLeadQuery
): Promise<DiagnosticLeadPagedResult> {
  const params = new URLSearchParams();

  params.set('page', String(query.page));
  params.set('pageSize', String(query.pageSize));

  if (query.search) {
    params.set('search', query.search);
  }

  if (query.diagnosticType) {
    params.set('diagnosticType', query.diagnosticType);
  }

  const res = await api.get<DiagnosticLeadPagedResult>(
    `/api/diagnostics/leads?${params.toString()}`
  );
  
  return res.data;
}